"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tabs_1 = require("./Tabs");
exports.default = Tabs_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/index.js
// module id = 1267
// module chunks = 8